export default "__VITE_PUBLIC_ASSET__dd4ccfca__"